import { initializeApp } from 'firebase/app';
import firebase from 'firebase/compat/app';
 import { getAuth } from "firebase/auth";
const firebaseConfig = {


    apiKey: "AIzaSyDZLa23ZE1HIbiZNqWcat3NM7GpoWxU6Cc",
    authDomain: "atha-yoga---mob-app.firebaseapp.com",
      databaseURL: 'https://atha-yoga---mob-app.firebaseio.com',   
    projectId: "atha-yoga---mob-app",
    storageBucket: "atha-yoga---mob-app.appspot.com",
    messagingSenderId: "702781590911",
    appId: "1:702781590911:android:67aad1ffff6a441c5a9e4a",
};
 
const app =  initializeApp(firebaseConfig);

let auth =  getAuth(app);;

export { auth,firebase };